import cx from 'clsx';
import React from 'react';

import style from './style.module.scss';

export type TVariant = 'warning' | 'caution';

interface IProps {
  id?: string;
  variant: TVariant;
  text: string;
  tooltipContent?: string;
  className?: string;
}

const ChatLabel: React.FC<IProps> = ({ id, variant, text, className }) => {
  return (
    <div className={cx(style.label, style[variant], className)} id={id}>
      {text}
    </div>
  );
};

export default ChatLabel;
